import { MB_SIZE } from 'constants/file';

export const TEAM_CHAT_MESSAGES_SCROLL_THRESHOLD_PX = 80;

export const TEAM_CHAT_INPUT_PLACEHOLDER = 'Type a message...';

export const TEAM_CHAT_MENTION_TRIGGER_REGEX = /@([\w.-]*)$/;

export const TEAM_CHAT_MENTION_TOKEN_REGEX = /@([\w.-]+)/g;

export const TEAM_CHAT_REACTION_EMOJIS = ['👍', '❤️', '😂', '🎉', '🙌', '😮', '😢', '🔥'];

export const TEAM_CHAT_ATTACHMENT_MAX_MB = 100;

export const TEAM_CHAT_ATTACHMENT_MAX_BYTES = TEAM_CHAT_ATTACHMENT_MAX_MB * MB_SIZE;

export const TEAM_CHAT_IMAGE_CONTENT_TYPE_PREFIX = 'image/';

export const TEAM_CHAT_SHARE_VIEW_TOOLTIP = 'Share current view';

export const TEAM_CHAT_SLASH_TRIGGER_REGEX = /^\/([\w-]*)$/;

export const TEAM_CHAT_SLASH_MAX_SUGGESTIONS = 6;

export const TEAM_CHAT_FALLBACK_MEMBER_NAME = 'Member';

// Only fires at the start of a word (start-of-string or preceded by whitespace) so a mid-word
// "#" (rare, but e.g. inside a pasted URL fragment) never opens the entity picker.
// Query is capped at two words so a `#` typed mid-sentence stops hijacking the composer at the
// second space (multi-word entity labels like "Marcus Reyes" stay searchable).
export const TEAM_CHAT_ENTITY_TRIGGER_REGEX = /(?<=^|\s)#([^\s#\n]*(?:\s[^\s#\n]*)?)$/;

// Non-greedy up to the first closing `]]` — a label may itself contain `|`, so the label group
// happily consumes it; a genuinely malformed/unterminated token simply fails to match and the
// raw text is left as-is by the caller.
export const TEAM_CHAT_ENTITY_TOKEN_REGEX = /\[\[([a-zA-Z]+):([\w-]+)\|([\s\S]*?)]]/g;

export const TEAM_CHAT_ENTITY_MAX_SUGGESTIONS_PER_GROUP = 8;
